/**
 * Tab slugs that appear in a page's `?tab=` query and are referenced from more than one module.
 */
export const SHARED_TABS = {
  /** Comments & activity log panel — asset, control, requirement, policy, policy version. */
  COMMENTS_AND_LOGS: 'comments',

  /** Control assessment panel — the target of the assessment deep links from Concepts and Jobs. */
  CONTROL_ASSESSMENT: 'Assessment',

  /** Policy version history — also the target of the `management-policy-versions` redirect. */
  POLICY_VERSION_HISTORY: 'version_history',
} as const;
